import { render } from "./DocDescriptionDocVerCom.vue?vue&type=template&id=8c8aa6bc&scoped=true"
import script from "./DocDescriptionDocVerCom.vue?vue&type=script&lang=js"
export * from "./DocDescriptionDocVerCom.vue?vue&type=script&lang=js"

import "./DocDescriptionDocVerCom.vue?vue&type=style&index=0&id=8c8aa6bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c8aa6bc"]])

export default __exports__